import React, {FunctionComponent} from "react";
import Box from "@mui/material/Box";
import {Outlet} from "react-router-dom";
import {useUtils} from "../../contexts";
import SpringMenu from "./SpringMenu";
import DrawerMenu from "./DrawerMenu";

const SpringLayout: FunctionComponent = () => {
  const {isMobile} = useUtils();

  return (
    <Box sx={{display: "flex", height: "100vh"}}>
      {isMobile ? (
        <DrawerMenu>
          <SpringMenu />
        </DrawerMenu>
      ) : (
        <SpringMenu />
      )}
      <Outlet />
    </Box>
  );
};
export default SpringLayout;
